import { render, staticRenderFns } from "./FileUploadModal.vue?vue&type=template&id=61218b5d&scoped=true"
import script from "./FileUploadModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUploadModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FileUploadModal.vue?vue&type=style&index=0&id=61218b5d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61218b5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61218b5d')) {
      api.createRecord('61218b5d', component.options)
    } else {
      api.reload('61218b5d', component.options)
    }
    module.hot.accept("./FileUploadModal.vue?vue&type=template&id=61218b5d&scoped=true", function () {
      api.rerender('61218b5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/fileUploadModal/FileUploadModal.vue"
export default component.exports